<template>
  <v-autocomplete
    :value="value"
    :items="items"
    item-text="name"
    item-value="id"
    :label="label"
    :return-object="true"
    :filter="filterItem"
    outlined
    chips
    multiple
    :rules="rules"
    :disabled="disabled"
    :loading="loading"
    @input="$emit('input', $event)"
  >
    <template v-slot:selection="{ item, parent, disabled: chipDisabled }">
      <v-chip
        :disabled="chipDisabled"
        close
        @click:close="parent.selectItem(item)"
      >
        <span class="bundle-items-select__id">#{{ item.id }}</span>
        {{ item.name }}
      </v-chip>
    </template>

    <template v-slot:item="{ item, attrs, on }">
      <v-list-item v-bind="attrs" v-on="on">
        <v-list-item-action>
          <v-simple-checkbox
            :value="attrs['aria-selected'] === 'true'"
            :ripple="false"
          />
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            <span class="bundle-items-select__id">#{{ item.id }}</span>
            {{ item.name }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
  /**
   * Выбор блюд в состав набора. Показывает id рядом с названием
   * и ищет по id (запрос из цифр, можно с ведущим #) или по названию.
   */
  export default {
    name: 'BundleItemsSelect',
    props: {
      value: {
        type: Array,
        default: () => [],
      },
      items: {
        type: Array,
        default: () => [],
      },
      label: {
        type: String,
        default: 'Блюда',
      },
      rules: {
        type: Array,
        default: () => [],
      },
      loading: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      filterItem (item, queryText) {
        const query = (queryText || '').trim().toLowerCase().replace(/^#/, '')

        if (!query) return true

        if (/^\d+$/.test(query)) {
          return String(item.id).startsWith(query)
        }

        return (item.name || '').toLowerCase().includes(query)
      },
    },
  }
</script>

<style scoped lang="less">
.bundle-items-select {
  &__id {
    margin-right: 6px;
    color: rgba(0, 0, 0, 0.45);
    font-size: 12px;
  }
}
</style>
